import { HexToRGBA } from "../Apps/SlideApp/Utils/OpacityUtils.js";

export const PageDefaultBackgroundImageOpacity = 1;
export const PageDefaultBorderImageOpacity = 1;

export function normalizePageBackgroundImageOpacity(value) {
  const parsed = Number(value);
  if (Number.isNaN(parsed)) return PageDefaultBackgroundImageOpacity;
  return Math.max(0, Math.min(1, parsed));
}

export const normalizePageBorderImageOpacity = normalizePageBackgroundImageOpacity;

/**
 * Builds stacked CSS background layers for page color overlay + optional background image fade.
 * Matches existing PageOpacity overlay behavior via HexToRGBA.
 */
export function buildPageBackgroundImageValue(page) {
  const color = page?.PageBackgroundColor || "#ffffff";
  const pageOpacity = page?.PageOpacity ?? 1;
  const imageOpacity = normalizePageBackgroundImageOpacity(page?.PageBackgroundImageOpacity);
  const colorOverlay = `linear-gradient(rgba(${HexToRGBA(color, pageOpacity)}), rgba(${HexToRGBA(
    color,
    pageOpacity,
  )}))`;

  if (!page?.PageBackgroundImage) {
    return colorOverlay;
  }

  if (imageOpacity >= 1) {
    return `${colorOverlay}, url(${page.PageBackgroundImage})`;
  }

  const { r, g, b } = hexToRgb(color);
  const fadeAlpha = Number((1 - imageOpacity).toFixed(2));
  const imageFade = `linear-gradient(rgba(${r}, ${g}, ${b}, ${fadeAlpha}), rgba(${r}, ${g}, ${b}, ${fadeAlpha}))`;

  return `${colorOverlay}, ${imageFade}, url(${page.PageBackgroundImage})`;
}

function hexToRgb(hex) {
  const clean = String(hex || "#ffffff").replace("#", "");
  if (!/^[0-9a-fA-F]{6}$/.test(clean)) {
    return { r: 255, g: 255, b: 255 };
  }
  return {
    r: parseInt(clean.slice(0, 2), 16),
    g: parseInt(clean.slice(2, 4), 16),
    b: parseInt(clean.slice(4, 6), 16),
  };
}
